import React from 'react'
import Page from '../components/Page'
import { Spinner, Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import { useLocation } from 'react-router-dom'
import classnames from 'classnames'
import PosStoreForm from '../components/PosStoreForm'
import PosStoreTable from '../components/PosStoreTable'
import PosTaxTable from '../components/PosTaxTable'
import PosPaymentTypeTable from '../components/PosPaymentTypeTable'
import PosScheduleTable from '../components/PosScheduleTable'
import PosScheduleTab from '../components/PosScheduleTab'
import PosShippingTable from '../components/PosShippingTable'
import PosPromoTable from '../components/PosPromoTable'
import PosMembershipTable from '../components/PosMembershipTable'

import moment from 'moment-timezone'

import { IconWidget, NumberWidget, TextWidget, BillWidget } from '../components/Widget'

import TextScroller from '../components/TextScroller'

class PosStorePage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')

  tabData = [{ name: 'Store' }, { name: 'Tax' }, { name: 'Payment Type' }, { name: 'Schedule' }, { name: 'Shipping' }, { name: 'Promo' }, { name: 'Membership' }]

  tabData2 = [{ name: 'Store' }]
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      Role: this.comp.Role,
      modal: false,
      confirmModal: false,
      isEdit: false,
      tabList: this.comp.Role == 'User' || this.comp.Role == 'External' ? this.tabData2 : this.tabData,
      activeTab: '1',
      redirect: false,
      disableTab: false,
      startdate: '',
      disable: '',
      billing_type: '',
      next_bill: '',
      billing_amt: '',
      payment_status: '',
      plan: '',
      store_limit: '',
      ecart_limit: '',
      product_limit: '',
      customer_limit: '',
      sms_credit: '',
      sms_count: '',
      store_count: '',
      ecart_count: '',
      product_count: '',
      customer_count: '',
      system_message: '',
      bill: [],
    }
  }

  componentDidMount() {
    //this.getStoreList();
    //this.getUserStore();

    // setTimeout(() => {
    this.getLicense()
    // }, )
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedStoreId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      let tabName = this.state.tabList[parseInt(tab) - 1].name

      this.setState({
        activeTab: tab,
      })
    }
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedStoreId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getStoreList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.selectedStoreId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getStoreList()
      })
      .catch(error => {
        alert(error)
      })
  }

  // getUserStore = () => {
  //   const user = StorageService.getSession('user_info');
  //   const comp = StorageService.getSession('selected_org');
  //   const url = process.env.REACT_APP_API_URL;
  //   const data = {
  //     session_key: user.session_key,
  //     CompanyID: comp.CompanyID,
  //     ProfileID: user.userId,
  //   };

  //   axios
  //     .post(url + ':3000/v1/user/getContentAccess', data)
  //     .then(response => {
  //       const result = response.data;
  //       if (result.error == true && result.message != 'Success') {
  //         alert(result.message);
  //         return;
  //       }
  //       StorageService.setSession('user_access', result.data);
  //       //this.getStoreList();
  //     })
  //     .catch(error => {
  //       alert(error);
  //     });
  // };

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            storeList: result.data,
            thFieldList: this.state.storeThList,
            tbFieldList: result.data,
            disableTab: result.data.length > 0 ? false : true,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getLicense = async () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')

    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v2/license/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            startdate: result.data.startdate,
            disable: result.data.disable,
            billing_type: result.data.billing_type,
            next_bill: result.data.next_bill ? moment(result.data.next_bill).tz('Asia/Singapore').format('YYYY-MM-DD') : '',
            billing_amt: result.data.billing_amt,
            payment_status: result.data.payment_status,
            plan: result.data.plan,
            store_limit: result.data.store_limit,
            ecart_limit: result.data.ecart_limit,
            product_limit: result.data.product_limit,
            customer_limit: result.data.customer_limit,
            sms_credit: result.data.sms_credit,
            sms_count: result.data.sms_count,
            store_count: result.data.store_count,
            ecart_count: result.data.ecart_count,
            product_count: result.data.product_count,
            customer_count: result.data.customer_count,
            system_message: result.data.system_message,
            bill: result.data.bill,
            isLoading: false,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  // CreatePaymentRequest = (amount, currency, order_id, id, admin_email) => async () => {
  //   const user = StorageService.getSession('user_info')
  //   const comp = StorageService.getSession('selected_org')
  //   const url = process.env.REACT_APP_UNITY_API2_URL
  //   const access = StorageService.getSession('user_access')

  //   const data_1 = {
  //     session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //   }

  //   let response = await axios.post(url + ':3000/v1/user/billing/hitpay/key', data_1)
  //   console.log(response.data.data)

  //   let { key, payment_methods } = response.data.data

  //   const headers = {
  //     'X-BUSINESS-API-KEY': key,
  //     //'Content-Type': 'application/x-www-form-urlencoded',
  //     'X-Requested-With': 'XMLHttpRequest',
  //   }

  //   const data = {
  //     session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //     email: admin_email,
  //     amount: amount,
  //     currency: currency,
  //     reference_number: order_id,
  //     webhook: 'https://fdpayment.unitysuite.app/v1/hitpay/notification',
  //     // redirect_url: 'https://home.unitysuite.app/posstore',
  //     redirect_url: 'https://home.unitysuite.app/loading',
  //     send_email: 'true',
  //     payment_methods: ["paynow_online"]
  //   }

  //   axios
  //     .post('https://api.hit-pay.com/v1/payment-requests', data, { headers })
  //     .then(async response => {
  //       if (this._isMounted) {
  //         this.setState({
  //           redirect_url: response.data.url,
  //         })

  //         await axios.post(url + ':3000/v1/user/billing/payment/update', {
  //           session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //           id,
  //           payment_id: response.data.id,
  //           order_id,
  //           currency,
  //           amount,
  //         })

  //         window.location.replace(response.data.url)
  //       }
  //     })
  //     .catch(error => {
  //       console.log(error)
  //       alert(error)
  //     })
  // }

  CreatePaymentRequest = (amount, currency, order_id, id, admin_email) => async () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      email: admin_email,
      amount: amount,
      currency: currency,
      reference_number: order_id,
      webhook: 'https://fdpayment.unitysuite.app/v1/hitpay/notification',
      // redirect_url: 'https://home.unitysuite.app/posstore',
      redirect_url: 'https://home.unitysuite.app/loading',
      send_email: 'true',
      payment_methods: ["paynow_online"]
    }

    axios
      .post(url + ':3000/v1/user/billing/hitpay/url', data)
      .then(async response => {
        if (this._isMounted) {
          
          this.setState({
            redirect_url: response.data.data.url,
          })

          await axios.post(url + ':3000/v1/user/billing/payment/update', {
            session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
            id,
            payment_id: response.data.data.id,
            order_id,
            currency,
            amount,
          })

          window.location.replace(response.data.data.url)
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  //  async function GetHitPayKey() {
  //   const url = process.env.REACT_APP_UNITY_API2_URL
  //   const data = {
  //     session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //   }

  //   axios
  //     .post(url + ':3000/v1/user/billing/hitpay/key', data)
  //     .then(response => {
  //       const result = response.data
  //       if (result.error == true && result.message != 'Success') {
  //         alert(result.message)
  //         return
  //       }

  //       return result
  //     })
  //     .catch(error => {
  //       alert(error)
  //     })
  // }

  store = id => {
    this.props.history.push({
      pathname: '/posstore/' + id,
    })
  }

  render() {
    const { activeTab, Role } = this.state
    return (
      <Page className="PosStorePage" title="Store" breadcrumbs={[{ name: 'Store', active: true, path: '/posstore' }]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        {this.state.system_message.length > 0 && (
          <>
            <TextScroller text={this.state.system_message} />
            <br />
          </>
        )}

        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {Role == 'Admin' && (
          <>
            {/* <Row>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Plan" text={this.state.plan} />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Billing Type" text={this.state.billing_type} />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Next Billing" text={this.state.next_bill} />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Status" span={this.state.system_message} text={this.state.payment_status} />
              </Col>
            </Row> */}
            <Row>
              <Col lg={3} md={6} sm={6} xs={12}>
                <NumberWidget
                  title="Total Stores"
                  number={this.state.store_count}
                  color="primary"
                  progress_color="default_secondary"
                  progress={{
                    value: this.state.store_count,
                    label: 'Limit',
                    max: this.state.store_limit,
                    count: this.state.store_limit,
                  }}
                />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <NumberWidget
                  title="Total Products"
                  number={this.state.product_count}
                  color="primary"
                  progress_color="default_secondary"
                  progress={{
                    value: this.state.product_count,
                    label: 'Limit',
                    max: this.state.product_limit,
                    count: this.state.product_limit,
                  }}
                />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <NumberWidget
                  title="Total Customer"
                  number={this.state.customer_count}
                  color="primary"
                  progress_color="default_secondary"
                  progress={{
                    value: this.state.customer_count,
                    label: 'Limit',
                    max: this.state.customer_limit,
                    count: this.state.customer_limit,
                  }}
                />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <NumberWidget
                  title="SMS Credit"
                  number={this.state.sms_credit}
                  color="primary"
                  progress_color="default_secondary"
                  progress={{
                    value: this.state.sms_count,
                    label: 'Total Used',
                    max: this.state.sms_credit,
                    count: this.state.sms_count,
                  }}
                />
              </Col>
            </Row>
            {this.state.bill.length > 0 && (
              <Row>
                {this.state.bill.map(item => {
                  return (
                    <Col lg={3} md={6} sm={6} xs={12} key={item.id}>
                      <BillWidget {...item} handleClick={this.CreatePaymentRequest(item.amount, item.currency, item.order_id, item.id, item.admin_email)} color="primary" progress_color="default_secondary" />
                    </Col>
                  )
                })}
              </Row>
            )}
          </>
        )}

        {this.state.isLoading == false && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString())
                            }}
                            disabled={this.state.disableTab}>
                            {item.name}
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <PosStoreTable store={this.store} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <PosTaxTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <PosPaymentTypeTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="4" className="py-3">
                      <PosScheduleTab isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="5" className="py-3">
                      <PosShippingTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="6" className="py-3">
                      <PosPromoTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="7" className="py-3">
                      <PosMembershipTable isGlobal={true} {...this.props} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {/* {(Role === 'Superuser' ||
          Role === 'Admin' ||
          Role === 'Manager' ||
          Role === 'Supervisor' ||
          Role === 'Financial') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString());
                            }}
                            disabled={this.state.disableTab}
                          >
                            {item.name}
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <PosStoreTable store={this.store} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <PosTaxTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <PosPaymentTypeTable isGlobal={true} />
                    </TabPane>
                    <TabPane tabId="4" className="py-3">
                      <PosScheduleTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="5" className="py-3">
                      <PosShippingTable isGlobal={true} {...this.props} />
                    </TabPane>
                    <TabPane tabId="6" className="py-3">
                      <PosPromoTable isGlobal={true} {...this.props} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )} */}
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosStoreForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Store</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}
export default PosStorePage
